import { createReducer } from 'reduxsauce';
import { NOTIFICATIONS } from 'actions/Base';
import _ from 'lodash/fp';
import { SUPPORTED_NOTIFICATIONS } from 'utils/constants.js'

export const INITIAL_STATE = {
  notificationsList: [],
  isLastPage: false,
  deviceToken: "",
  numberOfNotificationsNotClicked: 0,
  numberOfNotificationsNotSeen: 0,
  isLoading: false,
};

export const onRegisterDeviceRequest = (state, { payload }) => ({ ...state, isLoading: true });
export const onRegisterDeviceFailure = (state) => ({ ...state, isLoading: false });
export const onRegisterDeviceSuccess = (state, { payload }) => ({ ...state, isLoading: false, deviceToken: payload });

export const onGetNotificationsRequest = (state) => ({ ...state, isLoading: true });
export const onGetNotificationsFailure = (state) => ({ ...state, isLoading: false });
export const onGetNotificationsSuccess = (state, { payload }) => {
  
  const { content, pageable, last, size } = payload;
  const { pageNumber } = pageable

  // const uniqueContent = Object.values([...content, ...state.notificationsList], {}).reduce((unique, o) => {
  //     if(!unique.some(obj => obj.studentHitNotificationId === o.studentHitNotificationId)) {
  //       unique.push(o);
  //     }
  //     return unique;
  // },[]);

  // function compare( a, b ) {
  //   if ( a.created < b.created ){
  //     return 1;
  //   }
  //   if ( a.created > b.created ){
  //     return -1;
  //   }
  //   return 0;
  // }
  
  // // make sure list is ordered by created (date)
  // content.sort(compare);
  
  // if(pageNumber === 0) {
  //   uniqueContent.splice(size);
  // }

  // console.log('notificationsList', uniqueContent)

  return ({ ...state, 
    isLoading: false, 
    notificationsList: pageNumber !== 0 ? [].concat(state.notificationsList||[], content).filter(o => SUPPORTED_NOTIFICATIONS.includes(o.hitNotification.notificationType)) : content.filter(o => SUPPORTED_NOTIFICATIONS.includes(o.hitNotification.notificationType)),
    isLastPage: last
  });
}

// export const onSetNotificationClickedRequest = (state) => ({ ...state, isLoading: true });
// export const onSetNotificationClickedFailure = (state) => ({ ...state, isLoading: false });
// export const onSetNotificationClickedSuccess = (state, { payload }) => {
//   const notificationsListIndex = state.notificationsList.findIndex((notification) => (
//     (notification || {}).notificationId === payload.notificationId
//   ));
  
//   if (notificationsListIndex > -1) {
//     const current = _.cloneDeep(_.get(`notificationsList.[${notificationsListIndex}]`)(state) || {});

//     state.isLoading = false
//     state.numberOfNotificationsNotClicked = state.numberOfNotificationsNotClicked-1

//     if (current) {
//       current.clicked = true
//       return _.set(`notificationsList.[${notificationsListIndex}]`, current)(state);
//     }
//   }

//   return state;

// }

export const onPollRequest = (state) => ({ ...state, isLoading: true });

export const onPollSuccess = (state, { payload }) => { 
  return ({ ...state, 
    isLoading: false, 
    numberOfNotificationsNotClicked: payload.numberOfNotificationsNotClicked,
    numberOfNotificationsNotSeen: payload.studentHitNotificationIdsNotSeen.length
  });
};

/* eslint-disable no-param-reassign */
export const onPollFailure = (state) => { 
  state = {
    ...state, 
    isLoading: false 
  };
  return state;
};


export const ACTION_HANDLERS = {
  [NOTIFICATIONS.ADD_DEVICE_REQUEST]: onRegisterDeviceRequest,
  [NOTIFICATIONS.ADD_DEVICE_FAILURE]: onRegisterDeviceFailure,
  [NOTIFICATIONS.ADD_DEVICE_SUCCESS]: onRegisterDeviceSuccess,

  [NOTIFICATIONS.GET_NOTIFICATIONS_REQUEST]: onGetNotificationsRequest,
  [NOTIFICATIONS.GET_NOTIFICATIONS_FAILURE]: onGetNotificationsFailure,
  [NOTIFICATIONS.GET_NOTIFICATIONS_SUCCESS]: onGetNotificationsSuccess,

  // [NOTIFICATIONS.SET_NOTIFICATION_CLICKED_REQUEST]: onSetNotificationClickedRequest,
  // [NOTIFICATIONS.SET_NOTIFICATION_CLICKED_FAILURE]: onSetNotificationClickedFailure,
  // [NOTIFICATIONS.SET_NOTIFICATION_CLICKED_SUCCESS]: onSetNotificationClickedSuccess,

  [NOTIFICATIONS.POLL_REQUEST]: onPollRequest,
  [NOTIFICATIONS.POLL_FAILURE]: onPollFailure,
  [NOTIFICATIONS.POLL_SUCCESS]: onPollSuccess,
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
